export enum SpecialValidationType {
  Alpha = 'alpha',
  AlphaNum = 'alphanum',
  AlphaConfigurable = 'alphaExtended',
  Range = 'range',
  DenyFutureDates = 'denyFutureDates',
  None = 'none',
  DenyPastDates = 'denyPastDates',
  DuplicateString = 'duplicateString',
}
